module.exports = __webpack_public_path__ + "img/neurofeedback.3ac01bb4.png";